import { t } from 'i18next'

import * as yup from 'yup'

/**
 * Form constants
 */
const COURSE = 'course'
const ACADEMIC_PERIODS = 'academic_periods'
const TEACHERS = 'teachers'
const DATE_START = 'date_start'
const DATE_END = 'date_end'
const SCHEDULE = 'schedule'

/**
 * Form model
 */
const formModel = () => {
  return {
    [COURSE]: {
      label: `${t('common.course')}`,
      name: COURSE,
      required: true,
    },
    [ACADEMIC_PERIODS]: {
      label: `${t('school.academic-periods')}`,
      name: ACADEMIC_PERIODS,
    },
    [TEACHERS]: {
      label: `${t('common.teachers')}`,
      name: TEACHERS,
    },
    [DATE_START]: {
      label: `${t('common.date-start')}`,
      name: DATE_START,
      required: true,
    },
    [DATE_END]: {
      label: `${t('common.date-end')}`,
      name: DATE_END,
      required: true,
    },
    [SCHEDULE]: {
      label: `${t('common.schedule')}`,
      name: SCHEDULE,
    },
  }
}

/**
 * Form initial data
 */
export const initialValues = {
  [COURSE]: null,
  [ACADEMIC_PERIODS]: [],
  [TEACHERS]: [],
  [DATE_START]: '',
  [DATE_END]: '',
  [SCHEDULE]: {
    monday: {start_time: '', duration_minutes: ''},
    tuesday: {start_time: '', duration_minutes: ''},
    wednesday: {start_time: '', duration_minutes: ''},
    thursday: {start_time: '', duration_minutes: ''},
    friday: {start_time: '', duration_minutes: ''},
    saturday: {start_time: '', duration_minutes: ''},
    sunday: {start_time: '', duration_minutes: ''}
  }
}

/**
 * Form data validation
 */
export const validationSchema = () =>
  yup.object().shape({
    [COURSE]: yup
      .object()
      .nullable()
      .required(`${t('errors.required-error-message')}`),
    [DATE_START]: yup
      .date()
      .nullable()
      .required(`${t('errors.required-error-message')}`),
    [DATE_END]: yup
      .date()
      .nullable()
      .required(`${t('errors.required-error-message')}`),
    [ACADEMIC_PERIODS]: yup
      .array()
      .of(
        yup.object({
          id: yup.string(),
          title: yup.string(),
        }),
      )
      .min(1, `${t('errors.required-error-message')}`)
      .required(`${t('errors.required-error-message')}`),
  })

export default formModel
